import {
  OnestNormalSmall,
  OnestSemiBoldSmall,
} from "../../../components/styled/TextComponents";
import {
  color_blue_light,
  color_red_default,
  color_white,
} from "../../../constants/colors";
import { useI18n } from "../../../i18n/I18nProvider";

const PersonalEventPreview = ({
  eventData,
  onOpenPersonalEventEdit,
  onDeletePersonalEvent,
  isMenuOpen,
  onToggleMenu,
}) => {
  const { t } = useI18n();
  const [startTime, endTime] = eventData.timeSlot?.split(/\s*-\s*/) || ["", ""];

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: color_blue_light,
        display: "flex",
        flexDirection: "column",
        borderRadius: 12,
        padding: 10,
        boxSizing: "border-box",
        gap: 5,
        cursor: "pointer",
        transition: "background-color 0.3s ease, transform 0.3s ease",
      }}
      onClick={onToggleMenu}
    >
      <OnestSemiBoldSmall
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {eventData.title}
      </OnestSemiBoldSmall>
      <div
        style={{
          width: "100%",
          height: "auto",
          backgroundColor: color_white,
          borderRadius: 10,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 6px",
          boxSizing: "border-box",
        }}
      >
        <OnestNormalSmall style={{ marginTop: 8, marginBottom: 8 }}>
          {startTime}
          {endTime ? ` - ${endTime}` : ""}
        </OnestNormalSmall>
      </div>
      {isMenuOpen && (
        <div
          style={{
            backgroundColor: color_white,
            borderRadius: 10,
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
            padding: 10,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          <div
            style={{ color: color_red_default, cursor: "pointer" }}
            onClick={() => onOpenPersonalEventEdit(eventData)}
          >
            {t("Открыть")}
          </div>
          <div
            style={{ color: color_red_default, cursor: "pointer" }}
            onClick={() => onDeletePersonalEvent(eventData)}
          >
            {t("Удалить")}
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalEventPreview;
